import React, { useState } from 'react';
import { createReply } from '../services/replyService';
import MentionAutocomplete from './MentionAutocomplete';
import './ReplyForm.css';

const ReplyForm = ({ postId, user, channelId, onReplyCreated }) => {
  const [text, setText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!text.trim()) {
      setError('Please enter a reply');
      return;
    }

    if (text.trim().length > 300) {
      setError('Reply is too long. Maximum 300 characters allowed.');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await createReply(postId, text, user, channelId);
      setText('');
      if (onReplyCreated) {
        onReplyCreated();
      }
    } catch (error) {
      setError('Failed to post reply. Please try again.');
      console.error('Error creating reply:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="reply-form">
      <form onSubmit={handleSubmit}>
        <div className="reply-form-input">
          <MentionAutocomplete
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Write a reply... Use @username to mention someone"
            rows="2"
            disabled={isSubmitting}
            maxLength="300"
            onMentionSelect={(user) => {
              console.log('ReplyForm: User mentioned:', user.username);
            }}
          />
          <div className="reply-character-count">
            {text.length}/300
          </div>
        </div>

        {error && <div className="reply-error-message">{error}</div>}

        <div className="reply-form-actions">
          <button 
            type="submit" 
            className="reply-button"
            disabled={isSubmitting || !text.trim()}
          >
            {isSubmitting ? 'Replying...' : 'Reply'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReplyForm;